import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const fetchAllQuotations = async () => {
  const response = await fetch(`${REACT_APP_VMS_BASE_URL}/quotations`);
  const result = await response.json();
  return result;
};

export default fetchAllQuotations;
